const lookupRouteName = {
	brand: 'brands',
	cancelReason: 'cancel-reasons',
	channelType: 'channel-types',
	carrierType: 'carrier-types',
	color: 'colors',
	costType: 'cost-types',
	group: 'groups',
	manager: 'managers',
	onHoldReason: 'on-hold-reasons',
	returnReason: 'return-reasons',
	replacementReason: 'replacement-reasons',
	managerSync: 'managers/sync',
	season: 'seasons',
	size: 'sizes',
	status: 'status',
	searchKeyword: 'search-keywords',
	commerceProductCategory: 'commerce/lookups/product-categories',
	productCategory: 'fulfillment-product-categories',
	tagType: 'tag-types',
	productCountry: 'commerce/lookups/countries',
	state: 'commerce/lookups/states',
	country: 'commerce/lookups/countries',
	countryCustom: 'countries-custom',
	user: 'users',
	currency: 'currencies',
	exchangeRate: 'exchange-rates',
	fulfillmentMethod: 'fulfillment-methods',
	fulfillmentOrderStatus: 'fulfillment-order-statuses',
	closeOutType: 'close-out-types',
	orderStatus: 'order-statuses',
	discontinueReason: 'discontinue-reasons',
	orderType: 'order-types',
	productStatus: 'product-statuses',
	dimensionType: 'dimension-types',
	dimensionUnit: 'dimension-units',
	weightUnit: 'weight-units',
	addressType: 'commerce/lookups/address-types',
	confirmationType: 'confirmation-types',
	orderItemStatus: 'order-item-status',
	orderLineStatus: 'order-line-statuses',
	tag: 'tags',
	warehouse: 'warehouses',
	timezone: 'timezones',
	warehouseStatus: 'warehouse-statuses',
	condition: 'conditions',
	box: 'boxes',
	closeoutType: 'close-out-types',
	carrierServiceType: 'carrier-service-types',
	fulfillmentOrderError: 'fulfillment-order-errors',
	warehouseActivityType: 'warehouse-activity-types',
	organizationType: 'organization-types',
	receivingStatus: 'receiving-statuses',
	receivingType: 'receiving-types',
	shipmentInfoDeliveryStatus: 'shipment-info-delivery-statuses',
	carrierDeliveryStatus: 'carrier-delivery-statuses',
	weightUnit: 'weight-units',
	shipmentInfoChargeType: 'shipment-info-charge-types',
	warehouseManagementType: 'warehouse-management-types',
	customFieldVariable: 'custom-field-variables',
	reportFrequency: 'report-frequency',
	reportType: 'report-types',
	reportCategory: 'report-categories',
	carrierTypeServiceType: 'carrier-types-service-types',
	convertService: 'convert-services',
};

const lookupNames = {
	box: 'Box',
};

export { lookupRouteName, lookupNames };



// WEBPACK FOOTER //
// ./src/common/constants/lookupConstants.js